import lazyPage from '@monorepo/deprecated/core/hoc/lazyPage'

export default () => [
  {
    path: '/account/login',
    component: lazyPage(() =>
      import('App/View/Account').then(({ Login }) => Login)
    ),
    exact: true,
  },
  {
    path: '/account/logout',
    component: lazyPage(() =>
      import('App/View/Account').then(({ Logout }) => Logout)
    ),
    exact: true,
  },
  {
    path: '/account/registration',
    component: lazyPage(() =>
      import('App/View/Account').then(({ Registration }) => Registration)
    ),
    exact: true,
  },
  {
    path: '/account/reset-password',
    component: lazyPage(() =>
      import('App/View/Account').then(({ ResetPassword }) => ResetPassword)
    ),
    exact: true,
  },
  {
    path: '/resetting/reset/:token',
    component: lazyPage(() =>
      import('App/View/Account').then(({ ResetPassword }) => ResetPassword)
    ),
    exact: true,
  },
]
